export class CertificateValidationResponse {

  public valid = true;
  public message = '';

  constructor() {
  }
}
